import type { UserPermissionGrant } from '../stores/auth.store';
import { hasPermission } from './permissions';

export const canManageCompanies = (permissions: readonly UserPermissionGrant[]): boolean =>
  hasPermission(permissions, 'companies.manage', 'SYSTEM');

export const canReadCompanies = (permissions: readonly UserPermissionGrant[]): boolean =>
  hasPermission(permissions, 'companies.read', 'SYSTEM') || canManageCompanies(permissions);

export const canAdministerCompanies = (permissions: readonly UserPermissionGrant[]): boolean =>
  canManageCompanies(permissions) && hasPermission(permissions, 'trajectories.manage', 'SYSTEM');

export const canCreateCompanyLabels = (permissions: readonly UserPermissionGrant[]): boolean =>
  canManageCompanies(permissions) && hasPermission(permissions, 'companies.labels.add');
